var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile_bar_container"},[_c('span',{staticClass:"header"},[_vm._v("Możesz też znaleźć instrukcję według kategorii")]),_c('div',{staticClass:"bar"},_vm._l((_vm.categories),function(category){return _c('CategoryTile',{key:category.id,attrs:{"category":category}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }